import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    ReactiveFormsModule,
    MatButton,
    MatInputModule
  ],
  selector: 'equine-ui-nx-coupon-code',
  templateUrl: './coupon-code.component.html',
  styleUrls: ['./coupon-code.component.scss']
})
export class CouponCodeComponent implements OnInit  {

  @Input() disabled = false;
  @Output() couponApplied = new EventEmitter<string>();

  form: FormGroup | undefined;

  reqValidator = {
    validators: Validators.required,
    error: 'required',
  }

  constructor(
    private fb: FormBuilder
  ) { }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      coupon: ['', Validators.required]
    })
  }

  applyCoupon() {
    const coupon = this.form?.get('coupon')?.value;

    if (coupon) {
      this.couponApplied.emit(coupon);
    }
    this.form?.reset();
  }

}
